/* eslint-disable max-classes-per-file */
import Tabulator from 'tabulator-tables';

/* globals Knitiv */

/**
 * @typedef {Object} Column
 * @property {string} title
 */

/**
 * @typedef {Array<Column>} Columns
 */

/** @type {import('angular').IController} */
class TableController {
	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element
	 * @param {any} $scope
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ITimeoutService} $timeout
	 */
	constructor(
		$element,
		$scope,
		$rootScope,
		$timeout,
	) {
		this.$element = $element;
		this.$scope = $scope;
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;

		this.bordered = undefined;
		this.table = null;
		this.isLoading = false;
		this.isReady = false;

		/** @type {Columns} */
		this.columns = [];

		/** @type {any[]} */
		this.data = [];

		/** @type {Tabulator.Options} */
		this.options = {};

		this.onBuilding = () => {};
		this.onDataLoaded = () => {};
		this.onReady = () => {};
	}

	setup() {
		this.options ??= {};

		const element = this.$element.find('.data-table').get(0);

		const fr = {
			ajax: {
				loading: 'Chargement',
				error: 'Erreur',
			},
			pagination: {
				page_size: 'Éléments par page',
				page_title: 'Afficher la page',
				first: 'Début',
				first_title: 'Premiere page',
				last: 'Fin',
				last_title: 'Derniere page',
				prev: 'Préc.',
				prev_title: 'Page précédente',
				next: 'Suiv.',
				next_title: 'Page suivante',
				all: 'Tout',
			},
		};

		const options = {
			dataLoaded: () => {
				this.$timeout(() => {
					this.onDataLoaded();
				});
			},
			locale: true,
			langs: {
				'K_NODE;FRANCAIS': fr,
				fr,
			},
			maxHeight: '100%',
			tableBuilding: this.onBuilding,
			tableBuilt: () => {
				this.$timeout(() => {
					this.isReady = true;
					this.onReady();
				});
			},
			...this.options,
		};

		if (element) {
			this.table = new Tabulator(element, options);

			this.$scope.$on('changeLanguage', (
				/** @type {any} */ event,
				/** @type {{id: string}} */ { id },
			) => {
				this.table?.setLocale(id);
			});
		}
		// @ts-ignore
		this.table.setLocale(this.$rootScope.appConfig.lang.code);

		if (this.columns?.length > 0) {
			this.updateColumns();
		}
		if (this.data?.length > 0) {
			this.updateData();
		}
	}

	updateColumns() {
		this.columns ??= [];
		this.table?.setColumns(this.columns);
	}

	updateData() {
		this.data ??= [];
		this.table?.replaceData(this.data);
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (this.table) {
			if (changes.columns?.currentValue) {
				// this.updateColumns();
			}

			if (changes.data?.currentValue) {
				// this.updateData();
			}
		}

		if (changes.options?.currentValue) {
			this.setup();
		}
	}

	// eslint-disable-next-line class-methods-use-this
	$onInit() {
		if (this.rounded === undefined) {
			this.rounded = true;
		}
	}
}

export default TableController;
